import React from 'react'
import Layout from 'features/layout/components/Layout'
import Report from '../components/Report'

const ReportPage = (props) => {
  return (
    <Layout>
      <Report />
    </Layout>
  )
}

export default ReportPage
